import {  NgModule, Pipe, PipeTransform} from '@angular/core';


@Pipe({
    name: 'groupImageReplace',
    standalone: false
})

export class GroupImageReplace implements PipeTransform {

    transform(value: any, {groupId, groupName}): any {
        return value.replace('$$group-image$$', `<img
                alt="${groupName}"
                src="/images/Fittings/homecenter/Group_Images/${groupId}_Med.jpg"/>`)
    }

}

@NgModule({
    declarations: [GroupImageReplace],
    exports: [GroupImageReplace]
})
export class GroupImageReplaceModule {}
